// api.js
import { QUIZMASTER_API, AURUM_API } from '../config';

export const apiCall = async (endpoint, method = 'GET', body = null, useAurum = false, userId = null, accessToken = null) => {
    const baseApi = useAurum ? AURUM_API : QUIZMASTER_API;
    let url = `${baseApi}${endpoint}`;

    if (useAurum && userId && endpoint.includes('?user_id=')) {
        url = url.replace(/(\?|&)user_id=[^&]*/, '');
    }

    const headers = {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    };
    if (accessToken) {
        headers['Authorization'] = `Bearer ${accessToken}`;
    }

    const options = { method, headers };
    if (body) options.body = JSON.stringify(body);

    console.log(`[API Call] URL: ${url}, Method: ${method}`);

    try {
        const response = await fetch(url, options);
        const contentType = response.headers.get('content-type');
        let data;

        if (contentType && contentType.includes('application/json')) {
            data = await response.json();
        } else {
            data = await response.text();
        }

        if (!response.ok) {
            console.error(`[API Error] ${url}:`, { status: response.status, data });
            const error = new Error();
            error.status = response.status;
            error.detail = contentType && contentType.includes('application/json') ? data.detail || data.message : data;
            error.message = error.detail || `API request failed with status ${response.status}`;
            if (response.status === 401) {
                error.message = 'Authentication failed. Please try again.';
            }
            throw error;
        }

        return data;
    } catch (error) {
        console.error(`[API Call] Error for ${url}:`, {
            message: error.message,
            status: error.status,
            detail: error.detail,
        });
        throw error;
    }
};